<template>
    <AfValidationProvider v-slot="v"
                          :vid="vidComputed"
                          :disable-validation="disableValidation"
                          :name="validationLabel || labelComputed || ' '"
                          :mode="mode"
                          :rules="rules">
        <div class="form-floating" :class="{'form-floating--busy':busy}">
            <b-form-input :type="type"
                          :id="inputId"
                          v-bind="$attrs"
                          v-on="xListeners(['input'])"
                          :name="inputName"
                          :value="value"
                          @input.native="$emit('input', forceUppercase($event))"
                          :placeholder="placeholderComputed"
                          :state="getValidationState(v)"
                          :aria-describedby="inputName+'DataHelp'"
            />
            <label :for="inputId" v-text="labelComputed"></label>
            <b-form-invalid-feedback :id="inputId+'-live-feedback'">{{ v.errors[0] }}</b-form-invalid-feedback>
            <small v-if="tip" :id="inputId+'-data-help'" class="form-text text-muted">{{ tip }}</small>
            <div class="form-floating__spinner">
                <b-spinner v-if="busy" type="border" label="Loading..."></b-spinner>
            </div>
        </div>
    </AfValidationProvider>
</template>

<script>

import input from "@/components/inputs/mixins/input";
import xListeners from '@/mixins/xListeners';

export default {
    name: "FloatInput",
    mixins: [input, xListeners],
    props: {
        type: {
            default: 'text'
        },
        uppercase: {
            default: false
        }
    },
    methods: {
        forceUppercase(e) {
            if (!this.uppercase) return e.target.value
            const start = e.target.selectionStart;
            e.target.value = e.target.value.toUpperCase();
            e.target.setSelectionRange(start, start);
            return e.target.value;
        },
    }
}
</script>
